/** The pages a navigation can end on that are not the application: no account, no page, no session. */
export const account = {
  unknown: {
    title: "Geen account gevonden",
    description:
      "Het inloggen is gelukt, maar dit account is nog niet gekoppeld aan een persoon in de Wedstrijdplanner.",
    /** This door is JBNL's own Workspace, so the remedy is a colleague with beheerdersrechten
     * rather than the Aanmeldsite's veiligheidsregio hint (ADR-0018). */
    collegaBefore:
      "Vraag een collega met beheerdersrechten om je account te koppelen, of mail ",
    collegaAfter: ". Daarna kun je opnieuw inloggen.",
    aanmeldsiteBefore:
      "Wil je ploegen inschrijven of je beschikbaarheid doorgeven? Dat gaat via ",
    aanmeldsiteAfter:
      ". Gebruik daar het account van je veiligheidsregio. Dat adres staat meestal in het JBNL Portaal.",
  },

  signInFailed: {
    title: "Inloggen is niet gelukt",
    description:
      "Het inloggen is onderweg afgebroken. Meestal komt dat door een oud tabblad of de terugknop.",
    retry: "Opnieuw proberen",
  },

  notFound: {
    title: "Pagina niet gevonden",
    description: "Deze pagina bestaat niet.",
  },
} as const;
